import { StandingOrderIcon } from "./StandingOrderIcon";

export default StandingOrderIcon;
